import { ApiBlueprint, createFrontendPlugin, discoveryApiRef, fetchApiRef, PageBlueprint } from '@backstage/frontend-plugin-api';
import { adoptionMatrixApiRef, AdoptionMatrixClient } from './api';
import { adoptionRouteRef } from './routes';
import ScoreboardIcon from '@material-ui/icons/Score';

const adoptionMatrixApi = ApiBlueprint.make({
  params: defineParams => 
    defineParams({
      api: adoptionMatrixApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AdoptionMatrixClient({ fetchApi, discoveryApi }),
    }),
});

const adoptionOverviewPage = PageBlueprint.make({
  params: {
    path: '/adoption',
    title: 'Adoption',
    icon: <ScoreboardIcon />,
    routeRef: adoptionRouteRef,
    loader: () =>
      import('./components/AdoptionOverviewPage').then(m => <m.AdoptionOverviewPage />),
  },
});

const adoptionViewPage = PageBlueprint.make({
  name: 'adoption-view',
  params: {
    path: '/adoption/:name/view',
    title: 'Adoption Matrix View',
    icon: <ScoreboardIcon />,
    loader: () =>
      import('./components/AdoptionViewPage').then(m => <m.AdoptionViewPage />),
  },
});

const adoptionEditPage = PageBlueprint.make({
  name: 'adoption-edit',
  params: {
    path: '/adoption/:name/edit',
    title: 'Adoption Matrix Edit',
    icon: <ScoreboardIcon />,
    loader: () =>
      import('./components/AdoptionEditPage').then(m => <m.AdoptionEditPage />),
  },
});

const adoptionExportPage = PageBlueprint.make({
  name: 'adoption-export',
  params: {
    path: '/adoption/export',
    title: 'Adoption Export to Excel',
    icon: <ScoreboardIcon />,
    loader: () =>
      import('./components/AdoptionExportPage').then(m => <m.AdoptionExportPage />),
  },
});

const adoptionSummaryPage = PageBlueprint.make({
  name: 'adoption-summary',
  params: {
    path: '/adoption/summary',
    title: 'Adoption Matrix Summary',
    icon: <ScoreboardIcon />,
    loader: () =>
      import('./components/AdoptionSummaryPage').then(m => <m.AdoptionSummaryPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'adoption',
  extensions: [
    adoptionMatrixApi,
    adoptionOverviewPage,
    adoptionViewPage,
    adoptionEditPage,
    adoptionExportPage,
    adoptionSummaryPage,
  ],
  routes: {
    root: adoptionRouteRef,
  },
});